import { gql } from "@apollo/client";

export const CREATE_USER = gql`
  mutation registerUser($input: UserInput!) {
    registerUser(input: $input)
  }
`;
